/* eslint-disable no-unsafe-optional-chaining */
import { Box, CircularProgress } from "@material-ui/core";
import SettingsIcon from '@mui/icons-material/Settings';
import clsx from "clsx";
import { useState, useEffect, useMemo, useCallback } from "react";
import { ReactComponent as ArrowIcon } from "../../assets/images/arrow-big.svg";
import { Line, Typography } from "../../ui";
import "./Segment.scss";
import useRegions from '../../data/useRegions';
import usePreferences from "../../data/usePreferences";
import { SEGMENTS_MAIN, expandSegmentInterests } from "./consts/segments_main";
import Button from "@mui/material/Button";
import { Checkbox, Grid, MenuItem } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import { useFormik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ControlledTreeView from "./PreferencesSet";
import SegmentMap from "./SegmentMap";
import * as Yup from "yup";
import { useSnackbar } from "notistack";


import { updateSegment } from "../../redux/segments/actions";
import Dropzone from "react-dropzone";
import { citiesByRegions } from "../../modules/AdminPanel/Ssp/citiesByRegions";
import SearchIcon from "@mui/icons-material/Search";
import Chip from "@mui/material/Chip";
import { ListSubheader, InputAdornment } from "@mui/material";
import { client } from "../../utils/network";


const GENDER_TYPES = [
    { value: "male", label: "Мужской" },
    { value: "female", label: "Женский" },
    { value: "both", label: "Учитывать оба" },
];

const FORMIK_INITIAL_VALUES = {
    name: "",
    sex: [],
    age: {
        from: "",
        to: "",
        exclude: [],
    },
    regions: [],
    local_geo: { locations: [] },
    interests: [],
    campaign_list: [],
    search_phrases: {
        phrases: [],
        stop_phrases: [],
    },
    crm: {},
}

const CreateSegmentSchema = Yup.object().shape({
    name: Yup.string().required(),
    sex: Yup.array().required(),
    age: Yup.object().shape({
        from: Yup.number().min(18).max(100),
        to: Yup.number().min(18).max(100).when(
            "from", (from, field) => from ? field.min(from) : field

        ),
        exclude: Yup.array().of(
            Yup.number().min(18).max(100).required()
        ),
    }).required(),
    income_level: Yup.object().shape({
        income_level_from: Yup.number().min(0),
        income_level_to: Yup.number().min(0).when(
            "income_level_from", (income_level_from, field) => income_level_from ? field.min(income_level_from) : field
        ),
        income_level_exclude: Yup.array().of(
            Yup.number().min(0).required()
        ),
    }),
    search_phrases: Yup.object().shape({
        phrases: Yup.array().of(
            Yup.string().matches(/^[a-zA-Zа-яА-Я0-9\s]*$/)),
        stop_phrases: Yup.array().of(
            Yup.string().matches(/^[a-zA-Zа-яА-Я0-9\s]*$/))
    })
})

const createInitialValues = (data) => {
    console.log("DATA", data)
    if (!data) return FORMIK_INITIAL_VALUES;
    const result = { ...FORMIK_INITIAL_VALUES };
    for (const key in result) {
        if (key in data) {
            result[key] = data[key];
        }
        if (data[key] === null) {
            result[key] = []
        }
    }
    // if (data?.sex) { result.sex = data.sex[0] }
    if (data?.sex) { 
        result.sex = data.sex;
    } else {
        result.sex = [];
    }
    if (!data?.age) {
        result.age = {
            from: "",
            to: "",
            exclude: [],
        }
    }
    else if (!data?.age?.from) { result.age.from = "" }
    else if (!data?.age?.to) { result.age.to = "" }
    else if (!data?.age?.exclude) { result.age.exclude = [] }
    if (!data?.search_phrases) {
        result.search_phrases = {
            phrases: [],
            stop_phrases: [],
        }
    } else if (!data?.search_phrases?.phrases) {
        result.search_phrases.phrases = []
    } else if (!data?.search_phrases?.stop_phrases) {
        result.search_phrases.stop_phrases = []
    }
    // Приводим local_geo к ожидаемому объекту с locations
    if (!data?.local_geo || !Array.isArray(data?.local_geo?.locations)) {
        result.local_geo = { locations: [] };
    }
    if (data?.segments && Array.isArray(data.segments)) {
        result.interests = expandSegmentInterests(data.segments);
    } else if (data?.interests || data?.interests_soc_dem) {
        const oldInterests = data.interests || [];
        const oldSocDem = data.interests_soc_dem || [];
        result.interests = expandSegmentInterests([...oldInterests, ...oldSocDem]);
    }
    console.log(result)
    return result;
};

const ITEM_HEIGHT = 66;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const VISUAL_GEO_OVERRIDE_CAMPAIGN_ID = "b52d8cdb-514c-4a41-9404-650928138599";
const VISUAL_GEO_OVERRIDE_SEGMENT_ID = "f08df311-4f4e-4c22-93b2-56fc4f44cf5a";
const VISUAL_GEO_OVERRIDE_CITY = "Киров";

const CityMenuItem = React.memo(({ city, regionName, isSelected, onToggle }) => (
  <MenuItem 
    key={regionName + "_" + city} 
    value={city} 
    onClick={onToggle}
    style={{ padding: "4px 16px", minHeight: "32px", fontSize: 14 }}
  >
    <Checkbox 
      checked={isSelected} 
      size="small"
      style={{ pointerEvents: "none", marginRight: "8px", padding: 0 }} 
    />
    {city}
  </MenuItem>
));

CityMenuItem.displayName = 'CityMenuItem';

const CitiesTreeSelect = ({ value, onChange }) => {
  const [selectedCities, setSelectedCities] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const selectedCitiesRef = React.useRef(selectedCities);
  
  // Обновляем ref при каждом изменении selectedCities
  React.useEffect(() => {
    selectedCitiesRef.current = selectedCities;
  }, [selectedCities]);

  useEffect(() => {
    if (value) {
      const cities = typeof value === 'string' 
        ? value.split(",").map((s) => s.trim()).filter((s) => s)
        : (Array.isArray(value) ? value : []);
      setSelectedCities(cities);
    }
  }, [value]);

  const allCitiesList = useMemo(() => {
    const list = [];
    Object.values(citiesByRegions).forEach((regionObj) => {
      Object.values(regionObj).forEach((cities) => {
        list.push(...cities);
      });
    });
    return list;
  }, []);

  const commit = useCallback((values) => {
    setSelectedCities(values);
    onChange(values);
  }, [onChange]);

  const toggleCity = useCallback((city) => {
    setSelectedCities((prev) => {
      const exists = prev.includes(city);
      const next = exists ? prev.filter((c) => c !== city) : [...prev, city];
      // НЕ вызываем onChange немедленно - только при закрытии dropdown
      return next;
    });
  }, []);

  const handleRemoveCity = useCallback((city) => {
    setSelectedCities((prev) => {
      const next = prev.filter((c) => c !== city);
      // Вызываем onChange для удаления снаружи dropdown
      onChange(next);
      return next;
    });
  }, [onChange]);

  const handleRemoveCityInside = useCallback((city) => {
    setSelectedCities((prev) => prev.filter((c) => c !== city));
  }, []);

  const regionCitiesSelectedState = (cities) => {
    const total = cities.length;
    const selected = cities.filter((c) => selectedCities.includes(c)).length;
    return { total, selected, all: selected === total && total > 0, none: selected === 0, some: selected > 0 && selected < total };
  };

  const toggleRegion = useCallback((cities) => {
    const { all } = regionCitiesSelectedState(cities);
    if (all) {
      const remaining = selectedCities.filter((c) => !cities.includes(c));
      commit(remaining);
    } else {
      const setAll = Array.from(new Set([...selectedCities, ...cities]));
      commit(setAll);
    }
  }, [selectedCities, commit]);

  const selectAllGlobal = useCallback(() => {
    commit(allCitiesList);
  }, [commit, allCitiesList]);

  const deselectAllGlobal = useCallback(() => {
    commit([]);
  }, [commit]);

  const filtered = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) return citiesByRegions;
    
    const result = {};
    Object.entries(citiesByRegions).forEach(([fo, regionObj]) => {
      const foMatch = fo.toLowerCase().includes(q);
      Object.entries(regionObj).forEach(([regionName, cities]) => {
        const regionMatch = regionName.toLowerCase().includes(q);
        const matchedCities = foMatch || regionMatch
          ? cities
          : cities.filter((city) => city.toLowerCase().includes(q));
        if (matchedCities.length > 0) {
          if (!result[fo]) result[fo] = {};
          result[fo][regionName] = matchedCities;
        }
      });
    });
    return result;
  }, [searchQuery]);

  const renderGrouped = useMemo(() => {
    if (Object.keys(filtered).length === 0) {
      return (
        <MenuItem disabled style={{ justifyContent: "center", opacity: 0.6, fontSize: 13, padding: "16px" }}>
          Ничего не найдено
        </MenuItem>
      );
    }
    
    return Object.entries(filtered).map(([fo, regionObj]) => (
      <div key={fo}>
        <ListSubheader disableSticky style={{ fontSize: 14, fontWeight: 600, padding: "0px 16px" }}>{fo}</ListSubheader>
        {Object.entries(regionObj).map(([regionName, cities]) => {
          const state = regionCitiesSelectedState(cities);
          return (
            <div key={regionName}>
              <ListSubheader disableSticky style={{ padding: "0px 16px", minHeight: "auto" }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <span style={{ fontSize: 13 }}>{regionName}</span>
                  <Button size="small" onClick={() => toggleRegion(cities)} style={{ fontSize: 11, padding: "2px 6px", minWidth: "auto" }}>
                    {state.all ? "Снять" : "Выбрать все"}
                  </Button>
                </Box>
              </ListSubheader>
              {cities.map((city) => (
                <CityMenuItem
                  key={regionName + "_" + city}
                  city={city}
                  regionName={regionName}
                  isSelected={selectedCities.includes(city)}
                  onToggle={() => toggleCity(city)}
                />
              ))}
            </div>
          );
        })}
      </div>
    ));
  }, [filtered, selectedCities, toggleCity, toggleRegion]);

  return (
    <Box sx={{ width: "60%", padding: "10px 0", textAlign: "start" }}>
      <FormControl fullWidth size="small">
        <Select
          multiple
          displayEmpty
          value={selectedCities}
          renderValue={() => "Выбор городов"}
          style={{ height: 32, background: "#FFFFFF", border: "1px solid #a9a9a9", marginBottom: "5px" }}
          sx={{ "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": { borderColor: "transparent" } }}
          onOpen={() => {
            setTimeout(() => document.getElementById("search-input-cities-segment").focus(), 100);
          }}
          onClose={() => {
            // Синхронизируем выбранные города с formik при закрытии
            onChange(selectedCitiesRef.current);
            setTimeout(() => setSearchQuery(""), 100);
          }}
          MenuProps={{ 
            autoFocus: false, 
            MenuListProps: { 
              autoFocusItem: false,
              style: { maxHeight: "calc(90vh - 100px)", overflow: 'auto', padding: "0px" }
            },
            PaperProps: { 
              style: { maxHeight: "90vh" }
            },
            disablePortal: false,
            variant: "menu"
          }}
        >
          <ListSubheader>
            <Box sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                mb: 1,
                maxWidth: "500px",
                maxHeight: "300px",
                overflowY: "auto",
                pt: 1,
                "&::-webkit-scrollbar": { display: "none" },
                "-ms-overflow-style": "none",
                "scrollbar-width": "none"
              }}>
              {selectedCities.slice(0, 20).map((city) => (
                <Chip
                  key={city}
                  label={city}
                  onDelete={() => handleRemoveCityInside(city)}
                  style={{ border: "2px solid #3f73f994", borderRadius: "15px", margin: "3px", color: "black" }}
                />
              ))}
              {selectedCities.length > 20 && (
                <Chip
                  key="more"
                  label={"+" + (selectedCities.length - 20)}
                  style={{ border: "2px dashed #3f73f994", borderRadius: "15px", margin: "3px", color: "black" }}
                />
              )}
            </Box>
            <Box sx={{ display: "flex", gap: 5, mb: 1, pb: 1 }}>
              <button onClick={selectAllGlobal} style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "5px 10px", fontSize: 14, borderRadius: 5 }}>
                Выбрать все
              </button>
              <button onClick={deselectAllGlobal} style={{ width: "fit-content", backgroundColor: "#dfe8ff", color: "#3f73f9", padding: "5px 10px", fontSize: 14, borderRadius: 5 }}>
                Снять все
              </button>
            </Box>
            <TextField
              size="small"
              placeholder="Поиск города/региона/ФО"
              fullWidth
              autoFocus
              value={searchQuery}
              id="search-input-cities-segment"
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onKeyDown={(e) => {
                if (e.key === "Backspace") {
                  setTimeout(() => document.getElementById("search-input-cities-segment").focus(), 100);
                }
                if (e.key !== "Escape") {
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          {renderGrouped}
        </Select>
      </FormControl>
      {selectedCities.length > 0 && (
        <Box sx={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          gap: 8, 
          mt: 1,
          maxWidth: "100%"
        }}>
          {selectedCities.map((city) => (
            <Chip
              key={city}
              label={city}
              size="medium"
              onDelete={() => handleRemoveCity(city)}
              style={{ 
                border: "2px solid #3f73f994", 
                borderRadius: "16px", 
                height: "32px",
                fontSize: "13px",
                fontWeight: "500",
                color: "black",
                backgroundColor: "#f5f8ff"
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

function Segment(seg) {
    const { regions } = useRegions();
    const { preferences } = usePreferences()
    const segment = seg.segment
    const isVisualGeoOverride =
        seg.campaignId === VISUAL_GEO_OVERRIDE_CAMPAIGN_ID &&
        segment?.id === VISUAL_GEO_OVERRIDE_SEGMENT_ID;
    const [openSegment, setOpenSegment] = useState(false);
    const [progress, setProgress] = useState(0);
    const [editSegment, setEditSegment] = useState(false);
    const toggleOpenSegment = () => setOpenSegment(!openSegment);
    // eslint-disable-next-line no-unused-vars
    const [isGenderOpen, setIsGenderOpen] = React.useState(false);
    // eslint-disable-next-line no-unused-vars
    const [isAgeOpen, setIsAgeOpen] = React.useState(false);
    const [isGeoOpen, setIsGeoOpen] = React.useState(false);
    const [isPreferencesOpen, setIsPreferencesOpen] = React.useState(false);
    const [isCampaignOpen, setIsCampaignOpen] = React.useState(false);
    const [isPhrasesOpen, setIsSearchHistoryOpen] = React.useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const campaigns = useSelector(state => state.createNewCompany.campaigns);
    const dispatch = useDispatch();
    function nonEmptyObject(obj) {
        const preserveEmptyKeys = new Set(["regions", "local_geo"]);
        for (const propName in obj) {
            if (preserveEmptyKeys.has(propName)) continue;
            const value = obj[propName];
            const isEmptyArray = Array.isArray(value) && value.length === 0;
            if (
                value === null ||
                value === undefined ||
                value === "" ||
                isEmptyArray
            ) {
                delete obj[propName];
            }
        }
        return obj;
    }

    const validateCsvFile = (file) => {
        return new Promise((resolve, reject) => {
            // Проверяем расширение файла
            if (!file.name.toLowerCase().endsWith('.csv')) {
                reject("Файл должен иметь формат CSV");
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const text = e.target.result;
                    const lines = text.split('\n').filter(line => line.trim());
                    
                    if (lines.length === 0) {
                        reject("Файл пустой");
                        return;
                    }

                    const firstLine = lines[0].trim();
                    const headers = firstLine.split(/[,;]/).map(h => h.trim().toLowerCase());
                    
                    if (headers.length < 1 || headers.length > 2) {
                        reject("Файл должен содержать 1 или 2 столбца");
                        return;
                    }

                    const validHeaders = ['email', 'phone'];
                    const hasValidHeaders = headers.every(header => 
                        validHeaders.some(valid => header.includes(valid))
                    );

                    if (!hasValidHeaders) {
                        reject("Первая строка должна содержать заголовок 'email' или 'phone' в каждом столбце");
                        return;
                    }

                    resolve(true);
                } catch (error) {
                    reject("Ошибка при чтении файла: " + error.message);
                }
            };

            reader.onerror = () => {
                reject("Ошибка при чтении файла");
            };

            reader.readAsText(file);
        });
    };

    const uploadCrmFile = async (segmentId, file) => {
        if (!segmentId || !file) return;

        const formData = new FormData();
        formData.append("file", file);

        try {
            await client.post("/api/v1/new_segments/users-list", formData, {
                params: { segment_id: segmentId },
            });
        } catch (error) {
            console.error("Ошибка загрузки CRM файла для сегмента", segmentId, error);
            enqueueSnackbar("Не удалось загрузить CRM файл для сегмента", {
                variant: "error",
            });
        }
    };

    const formik = useFormik({
        initialValues: createInitialValues(segment),
        validationSchema: CreateSegmentSchema,
        onSubmit: async (values) => {
            // Валидация обязательных полей
            const errors = [];
            
            if (!values.name?.trim()) {
                errors.push("Название сегмента");
            }
            if (!values.sex?.length) {
                errors.push("Пол");
            }
            if (!values.age?.from && !values.age?.to && !values.age?.exclude?.length) {
                errors.push("Возраст");
            }
            if (selected === 'regions' && !values.regions?.length) {
                errors.push("Гео регионы");
            } else if (selected === 'maps' && !values.local_geo?.locations?.length) {
                errors.push("Локалгео");
            }
            
            if (errors.length > 0) {
                enqueueSnackbar(`Заполните обязательные поля: ${errors.join(', ')}`, { variant: 'error' });
                return;
            }
            const finalvalue = {
                name: values?.name,
                sex: [],
                age: {
                    from: "",
                    to: "",
                    exclude: [],
                },
                local_geo: {},
                regions: [],
                interests: [],
                interests_soc_dem: [],
                campaign_list: { campaign_ids: [] },
                search_phrases: {
                    phrases: [],
                    stop_phrases: []
                }
            }
            if (values.sex !== undefined && values.sex.length > 0) { 
                finalvalue.sex = values.sex;
            } else {
                finalvalue.sex = null;
            }
            let flag = true
            if (values.age.from !== "" || values.age.to !== "" || values.age.exclude.length !== 0) {
                finalvalue.age.from = values.age?.from
                finalvalue.age.to = values.age?.to
                finalvalue.age.exclude = values.age?.exclude
            } else {
                delete finalvalue.age
                flag = false
            }
            if (values.age?.from === "" && flag === true) { delete finalvalue.age.from }
            if (values.age?.to === "" && flag === true) { delete finalvalue.age.to }
            if (values.age?.exclude.length === 0 && flag === true) { delete finalvalue.age.exclude }

            // Геоданные: строго один источник по selected
            finalvalue.local_geo = { locations: [] };
            finalvalue.regions = [];
            if (selected === 'regions') {
                if (Array.isArray(values.regions) && values.regions.length > 0) {
                    finalvalue.regions = values.regions;
                }
                // local_geo остаётся пустым
            } else if (selected === 'maps') {
                const locations = Array.isArray(values?.local_geo?.locations)
                    ? values.local_geo.locations
                    : (Array.isArray(values?.local_geo) ? values.local_geo : []);
                if (locations.length > 0) {
                    finalvalue.local_geo.locations = locations;
                } else {
                    finalvalue.local_geo.locations = [];
                }
                // regions остаётся пустым
            }
            if (values.interests.length !== 0) {
                finalvalue.segments = values.interests;
            }
            if (values.campaign_list.length !== 0) {
                console.log("Add compaign")
                finalvalue.campaign_list.campaign_ids = values?.campaign_list
            } else { delete finalvalue.campaign_list }
            if (values.search_phrases.phrases.length !== 0 || values.search_phrases.stop_phrases.length !== 0) {
                finalvalue.search_phrases.phrases = values.search_phrases?.phrases
                finalvalue.search_phrases.stop_phrases = values.search_phrases?.stop_phrases
            } else { delete finalvalue.search_phrases }
            nonEmptyObject(finalvalue)
            console.log(finalvalue)
            console.log(segment.id)
            await dispatch(updateSegment(finalvalue, segment.id));

            // после обновления сегмента отправляем CRM файл, если он был добавлен
            const crmFile = formik.values?.crm?.file?.file;
            if (crmFile) {
                await uploadCrmFile(segment.id, crmFile);
            }
            setEditSegment(false)
            // todo: why 3?
            //if (values) props.handleChange("event", "3");
            //formik.setValues(FORMIK_INITIAL_VALUES);
            //console.log(values);
            //props.onClose();
        },
    });

    // Temp formik context of values and touched
    const [tempFormikValues, setTempFormikValues] = useState(null);
    const [tempFormikTouched, setTempFormikTouched] = useState(null);
    const [selected, setSelected] = useState('regions');
    const [isRegions, setRegions] = React.useState(true)
    const [isMaps, setMaps] = React.useState(false)

    useEffect(() => {
        const hasRegions = Array.isArray(segment?.regions) && segment.regions.length > 0;
        setSelected(hasRegions ? "regions" : "maps");
        setMaps(!hasRegions);
        setRegions(hasRegions);
    }, [seg.segment])

    const handleChange = (event) => {
        const next = event?.target?.value;
        if (!next) return;
        setSelected(next);
        const showRegions = next === 'regions';
        setRegions(showRegions);
        setMaps(!showRegions);
    }

    console.log(formik)
    const saveFormikContext = () => {
        setTempFormikValues(formik.values);
        setTempFormikTouched(formik.touched);
    }
    const restoreFormikContext = () => {
        formik.setValues(tempFormikValues);
        formik.setTouched(tempFormikTouched);
        setTempFormikValues(null);
        setTempFormikTouched(null);
    }
    const clearFormikContext = () => {
        setTempFormikValues(null);
        setTempFormikTouched(null);
    }

    // Gender handlers
    const handleOpenGender = () => {
        setIsGenderOpen(true);
    };
    const handleCancelGender = () => {
        setIsGenderOpen(false);
    };
    const handleApplyGender = () => {
        setIsGenderOpen(false);
    }
    const handleResetGender = () => {
        formik.setFieldValue("sex", []);
        setIsGenderOpen(false);
    }

    // age handlers
    const handleOpenAges = () => {
        setIsAgeOpen(true);
    };
    const handleCancelAges = () => {
        setIsAgeOpen(false);
    };
    const handleApplyAges = () => {
        setIsAgeOpen(false);
    }
    const handleResetAges = () => {
        formik.setFieldTouched("age", false);
        formik.setFieldValue("age.from", FORMIK_INITIAL_VALUES.age.from);
        formik.setFieldValue("age.to", FORMIK_INITIAL_VALUES.age.to);
        formik.setFieldValue("age.exclude", FORMIK_INITIAL_VALUES.age.exclude);
        setIsAgeOpen(false);
    }

    // Geo handlers
    const handleOpenGeo = () => {
        saveFormikContext();
        setIsGeoOpen(true);
    };
    // const handleCancelGeo = () => {
    //     restoreFormikContext();
    //     setIsGeoOpen(false);
    // };
    const handleApplyGeo = () => {
        clearFormikContext();
        setIsGeoOpen(false);
    }
    // const handleResetGeo = () => {
    //     clearFormikContext();
    //     //formik.setFieldTouched("geo", false);
    //     formik.setFieldValue("local_geo", FORMIK_INITIAL_VALUES.local_geo);
    //     formik.setFieldValue("regions", FORMIK_INITIAL_VALUES.regions);
    //     setIsGeoOpen(false);
    // }

    // Preferences handlers
    const handleOpenPreferences = () => {
        saveFormikContext();
        setIsPreferencesOpen(true);
    };
    const handleCancelPreferences = () => {
        restoreFormikContext();
        setIsPreferencesOpen(false);
    };
    const handleApplyPreferences = () => {
        clearFormikContext();
        setIsPreferencesOpen(false);
    }
    const handleResetPreferences = () => {
        clearFormikContext();
        //formik.setFieldTouched("interests", false);
        formik.setFieldValue("interests", FORMIK_INITIAL_VALUES.interests);
        setIsPreferencesOpen(false);
    }

    // Campaigns handlers
    const handleOpenCampaign = () => {
        saveFormikContext();
        setIsCampaignOpen(true);
    };
    const handleCancelCampaign = () => {
        restoreFormikContext();
        setIsCampaignOpen(false);
    };
    const handleApplyCampaign = () => {
        clearFormikContext();
        setIsCampaignOpen(false);
    }
    const handleResetCampaign = () => {
        clearFormikContext();
        formik.setFieldValue("campaign_list", FORMIK_INITIAL_VALUES.campaign_list);
        setIsCampaignOpen(false);
    }

    // Search history handlers
    const handleOpenSearchHistory = () => {
        saveFormikContext();
        setIsSearchHistoryOpen(true);
    };
    const handleCloseSearchHistory = () => {
        restoreFormikContext();
        setIsSearchHistoryOpen(false);
    };
    const handleApplySearchHistory = () => {
        clearFormikContext();
        setIsSearchHistoryOpen(false);
    }
    const handleResetSearchHistory = () => {
        clearFormikContext();
        formik.setFieldValue("search_phrases.phrases", FORMIK_INITIAL_VALUES.search_phrases.phrases)
        formik.setFieldValue("search_phrases.stop_phrases", FORMIK_INITIAL_VALUES.search_phrases.stop_phrases)
        setIsSearchHistoryOpen(false);

    }

    const handleReset = () => {
        formik.setValues(createInitialValues(segment))
        setEditSegment(false)
        //formik.setValues(FORMIK_INITIAL_VALUES);
        //props.onClose();
    }

    const getSelectedCampaignsNames = (ids) => {
        //console.log(ids)
        const selected = campaigns.filter(campaign => ids.includes(campaign.id));
        // console.log(selected)
        const names = selected.map(campaign => campaign.basic_config.name);
        return names;
    }


    function printsex(arr) {
        let str = ""
        if (Array.isArray(arr)) {
            if (arr.length === 2) {
                str += "Женский/Мужской"
            }
            else if (arr.length === 1 && arr[0] === "male") { str += "Мужской" }
            else if (arr.length === 1 && arr[0] === "female") { str += "Женский" }
        } else if (arr === "both") { 
            str += "Женский/Мужской" 
        }
        return str
    }

    function printages(arr) {
        let str = ""
        if (arr?.from && arr?.to) {
            str += `${arr.from}-${arr.to}`
        } else if (arr?.from) {
            str += `от ${arr.from}`
        } else if (arr?.to) {
            str += `до ${arr.to}`
        }
        //if (arr.exclude?.length !== 0) str += `, исключая ${arr.exclude}`
        return str
    }

    function printCities(arr) {
        if (!arr || !Array.isArray(arr) || !arr.length) return "";
        return arr.join(", ");
    }

    function formatNumber(val) {
        return new Intl.NumberFormat("ru-RU").format(val || 0);
    }

    function findSegmentByIabCode(iabCode) {
        for (const segment of SEGMENTS_MAIN) {
            if (segment.iabCode === iabCode) {
                return segment;
            }
            const child = segment.children?.find(child => child.iabCode === iabCode);
            if (child) {
                return child;
            }
        }
        return null;
    }

    function printInterestsSimple(arr) {
        const segments = arr
            .map(iabCode => findSegmentByIabCode(iabCode))
            .filter(Boolean)
            .slice(0, 6);
        let str = "";
        if (!segments.length) return "";
        segments.forEach((el) => (str += `${el.name}, `));
        return str.slice(0, -2);
    }

    const audienceByLeafCode = React.useMemo(() => {
        const map = {};
        SEGMENTS_MAIN.forEach(parent => {
            (parent.children || []).forEach(child => {
                if (child?.iabCode) {
                    map[child.iabCode] = child.audience || 0;
                }
            });
        });
        return map;
    }, []);

    const maxAudienceAll = React.useMemo(() => {
        return Object.values(audienceByLeafCode).reduce((a, b) => a + (b || 0), 0);
    }, [audienceByLeafCode]);

    const calcSelectedAudience = React.useCallback((codes) => {
        if (!Array.isArray(codes)) return 0;
        const selected = new Set(codes);
        let sum = 0;
        Object.keys(audienceByLeafCode).forEach(code => {
            if (selected.has(code)) {
                sum += audienceByLeafCode[code] || 0;
            }
        });
        return sum;
    }, [audienceByLeafCode]);

    useEffect(() => {
        if (!openSegment) return;
        const selectedCodes = segment.segments || formik?.values?.interests || [];
        const current = calcSelectedAudience(selectedCodes);
        const target = maxAudienceAll ? Math.min(100, Math.round((current / maxAudienceAll) * 100)) : 0;
        setProgress(0);
        let raf;
        const start = performance.now();
        const duration = 800; // ms
        const animate = (t) => {
            const elapsed = t - start;
            const pct = Math.min(1, elapsed / duration);
            const eased = 1 - Math.pow(1 - pct, 3); // easeOutCubic
            setProgress(Math.round(target * eased));
            if (pct < 1) {
                raf = requestAnimationFrame(animate);
            }
        };
        raf = requestAnimationFrame(animate);
        return () => cancelAnimationFrame(raf);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openSegment, segment.segments, maxAudienceAll]);

    function printInterests(arrInterests, arrSocDem) {
        let arr = [];
        if (arrInterests && arrSocDem) {
            arr = [...arrInterests, ...arrSocDem];
        } else if (arrInterests) {
            arr = arrInterests;
        } else if (arrSocDem) {
            arr = arrSocDem;
        }
        
        const segments = arr
            .map(iabCode => findSegmentByIabCode(iabCode))
            .filter(Boolean)
            .slice(0, 10);
        let str = '';
        if (!segments.length) return "";
        segments.forEach((el) => str += `${el.name}, `);
        return str.slice(0, -2);
    }

    function printCheckBox(arrInterests, arrSocDem) {
        let arr = [];
        if (arrInterests && arrSocDem) {
            arr = [...arrInterests, ...arrSocDem];
        } else if (arrInterests) {
            arr = arrInterests;
        } else if (arrSocDem) {
            arr = arrSocDem;
        }
        
        const selectedCodes = new Set(arr);
        const result = [...arr];
        
        SEGMENTS_MAIN.forEach(parent => {
            const allChildrenSelected = parent.children?.every(child => selectedCodes.has(child.iabCode));
            if (allChildrenSelected && parent.children?.length > 0 && !selectedCodes.has(parent.iabCode)) {
                result.push(parent.iabCode);
            }
        });
        
        return result;
    }
    function printSearchPhrases(arr) {
        if (!arr.length) return '';
        let str = '';
        arr.forEach((el) => str += `${el}, `)
        return str.slice(0, -2)
    }
    // function printRetarget(arr) {
    //     if (!arr?.length) return '';
    //     let str = '';
    //     arr.forEach((el) => str += `${el}, `)
    //     return str.slice(0, -2)
    // }

    function printallgeo(id) {
        if (!id) {
            console.log("wrong");
            return null;
        }
    
        const region = regions?.find(elem => elem.id === id);
    
        if (!region) {
            console.log("Region not found");
            return null;
        }
    
        return (
            <button className={id.startsWith('-') ? "catalog2" : "catalog"}>
                <Typography>
                    {region.name}
                </Typography>
            </button>
        );
      }

    function printallinterests(iabCode) {
        const segment = findSegmentByIabCode(iabCode);
        if (segment) {
            return (
                <button className="catalog" key={iabCode}>
                    <Typography>
                        <div className="body1">
                            {segment.name}
                        </div>
                    </Typography>
                </button>
            );
        }
        return null;
    }

    function printall_interests_soc_dem(iabCode) {
        const segment = findSegmentByIabCode(iabCode);
        if (segment) {
            return (
                <button className="catalog" key={iabCode}>
                    <Typography>
                        <div className="body1">
                            {segment.name}
                        </div>
                    </Typography>
                </button>
            );
        }
        return null;
    }

    return (
        <div>
            <div className={clsx("Card", seg.status)}>
                <div className="Segment">
                    <div className="segment-header">
                        <button type="button" onClick={toggleOpenSegment}>
                            <div className="column">
                                <ArrowIcon
                                    className={openSegment ? "segment-icon__open" : "segment-icon"}
                                />
                                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                    <Typography className="title" variant="h2" color="dark-gray">
                                        {segment.name}
                                    </Typography>
                                </Box>
                            </div>
                        </button>
                        <div className="column">
                            <Typography variant="body1" color="dark-gray">
                                Доступны <span className="hide">для привлечения:</span>
                            </Typography>
                            <Typography variant="body1" color="blue">
                                {formatNumber(calcSelectedAudience(segment.segments)) || "Идет подсчет охвата"}
                            </Typography>
                            <div className="settings" style={{ paddingLeft: 20 }}>
                                <button disabled={seg.disable} type="button" onClick={() => setEditSegment(!editSegment)}>
                                    <Typography variant="body1" color="dark-gray">
                                        <SettingsIcon />
                                    </Typography>
                                </button>
                            </div>
                        </div>
                    </div>
                    {openSegment &&
                        <div>
                            <div className="segment-content">
                                <div className="column">
                                    <div className="category">
                                        <div style={{ position: 'relative' }} className="circle">
                                            <div className="circle-gradient-bg"></div>
                                            
                                            <div className="circle-text-content">
                                                <div className="circle-number">
                                                    {(() => {
                                                        const selectedCodes = segment.segments || formik.values.interests || [];
                                                        const current = calcSelectedAudience(selectedCodes);
                                                        return formatNumber(current);
                                                    })()}
                                                </div>
                                                <div className="circle-unit">чел.</div>
                                                <div className="circle-description">Доступны для привлечения</div>
                                            </div>
                                            
                                            <svg style={{ position: 'absolute', width: 0, height: 0, pointerEvents: 'none' }}>
                                                <defs>
                                                    <linearGradient id="circleGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                                        <stop offset="0%" stopColor="#6b58e0" />
                                                        <stop offset="100%" stopColor="#3f73f9" />
                                                    </linearGradient>
                                                </defs>
                                            </svg>
                                            
                                            <CircularProgress 
                                                variant="determinate" 
                                                className="circle-progress" 
                                                value={progress} 
                                                size={210}
                                                thickness={3}
                                                sx={{
                                                    position: 'absolute',
                                                    zIndex: 3,
                                                    top: '50%',
                                                    left: '50%',
                                                    transform: 'translate(-50%, -50%)',
                                                    '& .MuiCircularProgress-circle': {
                                                        strokeLinecap: 'round',
                                                    },
                                                }}
                                            />
                                        </div>
                                        <div style={{ marginLeft: "20px" }} className="buttons">
                                            {(segment.sex !== null) &&
                                                <button className="catalog">
                                                    <Typography color="dark-gray">
                                                        <div className="body1">
                                                            {printsex(segment.sex)}
                                                        </div>
                                                    </Typography>
                                                </button>
                                            }
                                            {(segment.age !== null) && (
                                                <button className="catalog">
                                                    <Typography variant="body1" color="dark-gray">
                                                        <div className="body1">
                                                            {printages(segment.age)}
                                                        </div>
                                                    </Typography>
                                                </button>)
                                            }
                                            {(segment.regions !== null) &&
                                                segment.regions?.map(elem => printallgeo(elem)).slice(0, 5)
                                            }
                                            {(segment.segments !== null && segment.segments !== undefined) &&
                                                segment.segments?.map(elem => printallinterests(elem)).slice(0, 5)
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
            {editSegment ?
                <div>
                    <br />
                    <Grid
                        component="form"
                        className="createSegment"
                        sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "center" }}
                    >
                        <Grid
                            className="grid"
                            container
                            spacing={{ xs: 3, md: 3 }}
                            columns={{ xs: 2, sm: 8, md: 12 }}
                            rowSpacing={5}
                            alignItems="center"
                            justify="center"
                        >
                            <Grid item xs={12} >
                                <p
                                    className="title"
                                    style={{
                                        marginBottom: 14,
                                        height: 24,
                                        fontWeight: "bold",
                                        fontSize: 18,
                                    }}
                                >
                                    Название сегмента
                                </p>
                                <FormControl sx={{ width: "100%" }}>
                                    <TextField
                                        required
                                        sx={{ minWidth: 120, width: 250 }}
                                        label="Название"
                                        name="name"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.name}
                                        error={formik.errors.name && formik.touched.name}
                                        input={<OutlinedInput label="Название" />}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid className="gridItem" item xs={3}>
                                <p
                                    className="title"
                                    style={{
                                        marginBottom: 14,
                                        height: 24,
                                        fontWeight: "bold",
                                        fontSize: 18,
                                        textWrap: "nowrap",
                                    }}
                                >
                                    Социально-демографические
                                </p>
                                <FormControl sx={{ width: "100%" }}>
                                    {/* // todo: think how to move label in field when it not done */}
                                    <TextField
                                        name="gender"
                                        onClick={handleOpenGender}
                                        required
                                        label="Пол"
                                        value={formik.values.sex ? printsex(formik.values.sex) : ""}
                                        onMouseDown={event => event.preventDefault()}
                                        InputProps={{ readOnly: true }}
                                        id="outlined-multiline-flexible"
                                        sx={{ minWidth: 100, width: 230 }}
                                    />
                                    <Dialog open={isGenderOpen} 
                                    >
                                        <DialogTitle>Выберите пол</DialogTitle>
                                        <DialogContent>
                                            <Box className="modal" component="form" sx={{ display: "flex", flexWrap: "wrap" }}>
                                                <FormControl sx={{ m: 2, minWidth: 120, width: 350 }}>
                                                    <InputLabel id="gender_type-label">
                                                        Пол
                                                    </InputLabel>
                                                    <Select
                                                        labelId="gender_type-label"
                                                        id="sex"
                                                        name="sex"
                                                        value={Array.isArray(formik.values.sex) && formik.values.sex.length === 2 ? "both" : (formik.values.sex?.[0] || "")}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            if (value === "both") {
                                                                formik.setFieldValue("sex", ["male", "female"]);
                                                            } else {
                                                                formik.setFieldValue("sex", [value]);
                                                            }
                                                        }}
                                                        input={<OutlinedInput label="Пол" />}
                                                    >
                                                        {GENDER_TYPES.map(gender_type => (
                                                            <MenuItem
                                                                key={gender_type.value}
                                                                value={gender_type.value}
                                                            >
                                                                {gender_type.label}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={handleResetGender}>Сбросить</Button>
                                            <Button onClick={handleCancelGender}>Отмена</Button>
                                            <Button onClick={handleApplyGender}>Ok</Button>
                                        </DialogActions>
                                    </Dialog>
                                </FormControl>
                            </Grid>

                            {/* age data */}
                            <Grid className="socialItem" item xs={3}>
                                <p
                                    style={{
                                        marginBottom: 14,
                                        height: 24,
                                        fontWeight: "bold",
                                        fontSize: 18,
                                    }}
                                >
                                </p>
                                <FormControl sx={{ width: "100%" }}>
                                    <TextField
                                        name="age"
                                        required
                                        onClick={handleOpenAges}
                                        onMouseDown={event => event.preventDefault()}
                                        InputProps={{ readOnly: true }}
                                        label="Возраст"
                                        value={
                                            !formik.errors.age
                                                && (formik.values.age.from
                                                    || formik.values.age.to
                                                    || formik.values.age.exclude.length)
                                                ? printages(formik.values.age)
                                                : ""
                                        }
                                        sx={{ minWidth: 120, width: 230 }} />
                                    <Dialog disableEscapeKeyDown open={isAgeOpen}
                                    >
                                        <DialogTitle>Укажите возраст</DialogTitle>
                                        <DialogContent>
                                            <Box component="form" sx={{ display: "flex", flexWrap: "wrap", maxWidth: "100%" }}>
                                                <FormControl sx={{ m: 1, minWidth: 120, width: 350 }}>
                                                    <TextField
                                                        fullWidth
                                                        label="От"
                                                        value={formik.values.age.from}
                                                        name="age.from"
                                                        type="number"
                                                        onBlur={formik.handleBlur}
                                                        onChange={formik.handleChange}
                                                        sx={{ m: 1 }}
                                                        input={<OutlinedInput label="Возраст" />}
                                                        error={formik.errors.age?.from && formik.touched.age?.from}
                                                    />
                                                    <TextField
                                                        fullWidth
                                                        label="До"
                                                        type="number"
                                                        value={formik.values.age.to}
                                                        name="age.to"
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        sx={{ m: 1 }}
                                                        input={<OutlinedInput label="Возраст" />}
                                                        error={formik.errors.age?.to && formik.touched.age?.to}
                                                    />
                                                </FormControl>
                                            </Box>
                                            <Box component="form" sx={{ display: "flex", flexWrap: "wrap", maxWidth: "100%" }}>
                                                <FormControl sx={{ m: 2, minWidth: 120, width: 350 }}>
                                                    <TextField
                                                        fullWidth
                                                        label="Исключить возраст"
                                                        name="age.exclude"
                                                        id="fullWidth"
                                                        value={formik.values.age.exclude.join(",")}
                                                        onChange={
                                                            (e) => formik.setFieldValue(
                                                                "age.exclude",
                                                                e.target.value ? e.target.value.split(",") : []
                                                            )
                                                        }
                                                        onBlur={formik.handleBlur}
                                                        input={<OutlinedInput label="Исключить возраст" />}
                                                        error={formik.errors.age?.exclude && formik.touched.age?.exclude}
                                                    />
                                                </FormControl>
                                            </Box>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={handleResetAges}>Сбросить</Button>
                                            <Button onClick={handleCancelAges}>Отмена</Button>
                                            <Button
                                                onClick={handleApplyAges}
                                                disabled={Boolean(formik.errors.age)}
                                            >Ok</Button>
                                        </DialogActions>
                                    </Dialog>
                                </FormControl>
                            </Grid>

                            {/* Geo data */}
                            <Grid className="socialItem" item xs={3}>
                                <p
                                    style={{
                                        marginBottom: 14,
                                        height: 24,
                                        fontWeight: "bold",
                                        fontSize: 18,
                                    }}
                                >
                                </p>
                                <FormControl sx={{ width: "100%" }}>
                                    <div>
                                        <TextField
                                            name="geo"
                                            required
                                            value={
                                                isVisualGeoOverride
                                                    ? VISUAL_GEO_OVERRIDE_CITY
                                                    : selected === 'regions'
                                                    ? (formik.values.regions.length
                                                        ? printCities(formik.values.regions)
                                                        : "")
                                                    : ((Array.isArray(formik.values.local_geo?.locations) && formik.values.local_geo.locations.length)
                                                        ? formik.values.local_geo.locations.map(g => g.label).join(', ')
                                                        : "")
                                              }
                                            onClick={handleOpenGeo}
                                            onMouseDown={event => event.preventDefault()}
                                            InputProps={{ readOnly: true }}
                                            label="География"
                                            sx={{ minWidth: 120, width: 230, '& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled': { textOverflow: 'ellipsis' } }}
                                        />
                                        <Dialog disableEscapeKeyDown open={isGeoOpen}
                                            fullWidth maxWidth="md">
                                            <DialogTitle>Укажите гео-данные</DialogTitle>
                                            <DialogContent>
                                                <Box component="form" sx={{ display: "flex", flexWrap: "wrap", maxWidth: "100%", minHeight: 600 }}>
                                                    <FormControl sx={{
                                                        m: 2,
                                                        minWidth: 120,
                                                        width: "100%",
                                                        height: 380
                                                    }}>
                                                        <RadioGroup
                                                            aria-labelledby="demo-radio-buttons-group-label"
                                                            sx={{ width: "100%" }}>
                                                            <FormControlLabel value="regions"
                                                                control={<Radio
                                                                    checked={selected === 'regions'}
                                                                    onChange={handleChange}
                                                                    value="regions"
                                                                    name="radio-buttons"
                                                                />}
                                                                label="Города" />
                                                            <FormControlLabel value="maps"
                                                                control={<Radio
                                                                    disabled={false}
                                                                    checked={selected === 'maps'}
                                                                    onChange={handleChange}
                                                                    value="maps"
                                                                    name="radio-buttons"
                                                                    inputProps={{ 'aria-label': 'B' }}
                                                                />} label="Выбрать на карте" />
                                                        </RadioGroup>
                                                        {isRegions && (
                                                            <CitiesTreeSelect 
                                                                value={formik.values.regions} 
                                                                onChange={(value) => formik.setFieldValue("regions", value)} 
                                                            />
                                                        )}
                                                        {isMaps && (
                                                            <SegmentMap 
                                                                open={isMaps} 
                                                                value={formik.values.local_geo?.locations} 
                                                                onChange={(value) => formik.setFieldValue("local_geo", { locations: value })} 
                                                            />
                                                        )}
                                                    </FormControl>
                                                </Box>
                                            </DialogContent>
                                            <DialogActions>
                                                {/* <Button onClick={handleResetGeo}>Сбросить</Button> */}
                                                {/* <Button onClick={handleCancelGeo}>Отмена</Button> */}
                                                <Button onClick={handleApplyGeo}>Ok</Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                </FormControl>
                            </Grid>

                                                        {/* CRM данные */}
                                                        <Grid className="gridItem" item xs={6}>
                                <p
                                    className="title"
                                    style={{
                                        marginBottom: 10,
                                        height: 24,
                                        fontWeight: "bold",
                                        fontSize: 18,
                                    }}
                                >
                                    CRM данные
                                </p>
                                <Dropzone
                                    accept=".csv"
                                    multiple={false}
                                    maxSize={10 * 1024 * 1024} // 10 МБ
                                    onDrop={async (acceptedFiles, rejectedFiles) => {
                                        if (rejectedFiles && rejectedFiles.length > 0) {
                                            const rejection = rejectedFiles[0];
                                            if (rejection.errors.some(e => e.code === 'file-too-large')) {
                                                enqueueSnackbar("Размер файла не должен превышать 10 МБ", { variant: 'error' });
                                            } else if (rejection.errors.some(e => e.code === 'too-many-files')) {
                                                enqueueSnackbar("Можно загрузить только 1 файл", { variant: 'error' });
                                            } else {
                                                enqueueSnackbar("Ошибка при загрузке файла", { variant: 'error' });
                                            }
                                            return;
                                        }
                                        if (acceptedFiles && acceptedFiles.length > 0) {
                                            const [file] = acceptedFiles;
                                            try {
                                                await validateCsvFile(file);
                                                formik.setFieldValue("crm", {
                                                    file: {
                                                        file,
                                                        fileType: "",
                                                        fileName: file.name,
                                                    }
                                                });
                                                enqueueSnackbar("CRM Файл добавлен", { variant: 'success' });
                                            } catch (error) {
                                                enqueueSnackbar(error, { variant: 'error' });
                                            }
                                        }
                                    }}
                                >
                                    {({ getRootProps, getInputProps, isDragAccept, isDragReject }) => {
                                        const hasFile = formik.values.crm.file || segment.users_list_id;
                                        return (
                                        <div
                                            {...getRootProps({
                                                style: { 
                                                    marginTop: 0,
                                                    backgroundColor: hasFile ? "#e8f5e9" : undefined,
                                                    borderColor: hasFile ? "#4caf50" : undefined,
                                                },
                                                className: `dropzone1
                                    ${isDragAccept && "dropzoneAccept1"}
                                    ${isDragReject && "dropzoneReject1"}
                                    ${hasFile && "dropzoneSuccess"}`,
                                            })}
                                        >
                                            <input type="file" {...getInputProps()} />
                                            <div className="media-plan__drag-container">
                                                {
                                                    (formik.values.crm.file || segment.users_list_id)
                                                        ? <p style={{ textAlign: "center" }}>Файл добавлен</p>
                                                        : <p style={{ textAlign: "center" }}>Добавить файл</p>
                                                }
                                                <p style={{ fontSize: "11px" }} className="media-plan__drag-text">
                                                    Поддерживается файл формата: csv - используются данные из одного или двух столбцов, первой строчкой каждого столбца должен быть заголовок email или phone
                                                </p>
                                            </div>
                                        </div>
                                        );
                                    }}
                                </Dropzone>
                            </Grid>

                            {/* Preference data */}
                            <Grid className="gridItem" item xs={6} style={{ marginBottom: "79px" }}>
                                <p
                                    className="title"
                                    style={{
                                        marginBottom: 14,
                                        height: 24,
                                        fontWeight: "bold",
                                        fontSize: 18,
                                    }}
                                >
                                    Интересы (IAB категории)
                                </p>
                                <FormControl sx={{ width: "100%" }}>
                                    <>
                                        <TextField
                                            name="interests"
                                            disabled={false}
                                            value={
                                                segment.segments
                                                ? printInterests(segment.segments, null)
                                                : formik.values.interests.length ? printInterestsSimple(formik.values.interests) : ""}
                                            onClick={handleOpenPreferences}
                                            onMouseDown={event => event.preventDefault()}
                                            InputProps={{ readOnly: true }}
                                            label="Интересы"
                                            sx={{ minWidth: 120, width: 420, '& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled': { textOverflow: 'ellipsis' } }}
                                        />
                                        <Dialog disableEscapeKeyDown open={isPreferencesOpen}
                                            fullWidth maxWidth="sm">
                                            <DialogTitle>Выберите интересы</DialogTitle>
                                            <DialogContent>
                                                <Box component="form" sx={{ display: "flex", flexWrap: "wrap" }}>
                                                    <FormControl>
                                                        <ControlledTreeView
                                                            value={segment.segments || formik.values.interests}
                                                            onChange={(value) => formik.setFieldValue("interests", value)}
                                                        />
                                                    </FormControl>
                                                </Box>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={handleResetPreferences}>Сбросить</Button>
                                                <Button onClick={handleCancelPreferences}>Отмена</Button>
                                                <Button onClick={handleApplyPreferences}>Ok</Button>
                                            </DialogActions>
                                        </Dialog>
                                    </>
                                </FormControl>
                            </Grid>
                            {/* Campaigns select */}
                            {/* <Grid className="gridItem" item xs={6}>
                                <p
                                    className="title"
                                    style={{
                                        marginBottom: 14,
                                        height: 24,
                                        fontWeight: "bold",
                                        fontSize: 18,
                                    }}
                                >
                                    Ретаргетинг
                                </p>
                                <FormControl sx={{ width: "100%" }}>
                                    <div>
                                        <TextField
                                            name="campaign_list"
                                            value={formik.values.campaign_list.length ? getSelectedCampaignsNames(formik.values.campaign_list).join(", ") : ""}
                                            onClick={handleOpenCampaign}
                                            onMouseDown={event => event.preventDefault()}
                                            InputProps={{ readOnly: true }}
                                            label="Кампании"
                                            sx={{ minWidth: 120, width: 420 }} />
                                        <Dialog disableEscapeKeyDown open={isCampaignOpen} >
                                            <DialogTitle>Выберите Кампании</DialogTitle>
                                            <DialogContent>
                                                <Box component="form" sx={{ display: "flex", flexWrap: "wrap" }}>
                                                    <FormControl sx={{ m: 2, minWidth: 120, width: 350 }}>
                                                        <InputLabel id="select-campaigns-label">Кампании</InputLabel>
                                                        <Select
                                                            labelId="select-campaigns-label"
                                                            id="select-campaigns"
                                                            multiple
                                                            name="campaign_list"
                                                            value={formik.values.campaign_list}
                                                            onChange={formik.handleChange}
                                                            input={<OutlinedInput label="Кампании" />}
                                                            renderValue={selectedCampaigns => getSelectedCampaignsNames(selectedCampaigns).join(", ")} //getSelectedCampaignsNames(selectedCampaigns)
                                                            MenuProps={MenuProps}
                                                        >
                                                            {campaigns.filter(campaign => (campaign.id !== null)).map(campaign =>
                                                                <MenuItem key={campaign.id} value={campaign.id}>
                                                                    <Checkbox checked={formik.values.campaign_list.includes(campaign.id)} />
                                                                    <ListItemText primary={campaign.basic_config.name} />
                                                                </MenuItem>
                                                            )}
                                                        </Select>
                                                    </FormControl>
                                                </Box>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={handleResetCampaign}>Сбросить</Button>
                                                <Button onClick={handleCancelCampaign}>Отмена</Button>
                                                <Button onClick={handleApplyCampaign}>Ok</Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                </FormControl>
                            </Grid> */}

                            {/* Search history data */}
                            {/* <Grid className="gridItem" item xs={6} style={{ marginBottom: 35 }} >
                                <p
                                    className="title"
                                    style={{
                                        marginBottom: 14,
                                        height: 24,
                                        fontWeight: "bold",
                                        fontSize: 18,
                                    }}
                                >
                                    История поисковых запросов
                                </p>
                                <FormControl sx={{ width: "100%" }}>
                                    <div>
                                        <TextField
                                            name="search_phrases.phrases"
                                            // todo: add or remove category.
                                            value={
                                                formik.values.search_phrases.phrases.length
                                                    || formik.values.search_phrases.stop_phrases.length ?
                                                    printSearchPhrases(formik.values.search_phrases.phrases) : ""
                                            }
                                            onClick={handleOpenSearchHistory}
                                            onMouseDown={event => event.preventDefault()}
                                            InputProps={{ readOnly: true }}
                                            label="Поисковые запросы"
                                            sx={{ minWidth: 120, width: 420, '& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input.Mui-disabled': { textOverflow: 'ellipsis' } }}
                                        />
                                        <Dialog disableEscapeKeyDown open={isPhrasesOpen} maxWidth="sm" fullWidth>
                                            <DialogTitle>Выберите категорию</DialogTitle>
                                            <DialogContent>
                                                <Box component="form" sx={{ display: "flex", flexWrap: "wrap", maxWidth: "100%" }}>
                                                    <FormControl sx={{ m: 2, minWidth: 120, width: "100%" }}>
                                                        <TextField
                                                            id="outlined-multiline-static"
                                                            onChange={(e) => formik.setFieldValue("search_phrases.phrases", e.target.value ? e.target.value.split("\n") : [])}
                                                            value={formik.values.search_phrases.phrases.join("\n")}
                                                            name="search_phrases.phrases"
                                                            label="Поисковые фразы"
                                                            placeholder="Введите фразы, по которым ищут товар. Отделяйте разные фразы переносом строки."
                                                            multiline
                                                            rows={10}
                                                            error={formik.errors.search_phrases?.phrases}
                                                        />
                                                        {formik.errors.search_phrases?.phrases && <div style={{ color: 'red', marginTop: 5 }}>Только русский и английский алфавиты, цифры и пробелы разрешены</div>}
                                                    </FormControl>
                                                </Box>
                                                <Box component="form" sx={{ display: "flex", flexWrap: "wrap", maxWidth: "100%" }}>
                                                    <FormControl sx={{ m: 2, minWidth: 120, width: "100%" }}>
                                                        <TextField
                                                            label="Минус-фразы на список"
                                                            id="outlined-multiline-static"
                                                            name="search_phrases.stop_phrases"
                                                            multiline
                                                            placeholder="Введите общие минус-фразы. Отделяйте разные фразы переносом строки."
                                                            onChange={(e) => formik.setFieldValue("search_phrases.stop_phrases", e.target.value ? e.target.value.split("\n") : [])}
                                                            value={formik.values.search_phrases.stop_phrases.join("\n")}
                                                            // input={<OutlinedInput label="Исключить запросы" />} 
                                                            rows={5}
                                                            error={formik.errors.search_phrases?.stop_phrases}
                                                        />
                                                        {formik.errors.search_phrases?.stop_phrases && <div style={{ color: 'red', marginTop: 5 }}>Только русский и английский алфавиты, цифры и пробелы разрешены</div>}
                                                    </FormControl>
                                                </Box>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={handleResetSearchHistory}>Сбросить</Button>
                                                <Button onClick={handleCloseSearchHistory}>Отмена</Button>
                                                <Button onClick={handleApplySearchHistory} disabled={Boolean(formik.errors.search_phrases)}>Ok</Button>
                                            </DialogActions>
                                        </Dialog>
                                    </div>
                                </FormControl>
                            </Grid> */}

                        </Grid >

                        <Button variant="outlined" onClick={handleReset} style={{ marginTop: 25, marginRight: 15 }}>Отменить</Button>
                        <Button variant="contained" onClick={formik.handleSubmit} style={{ marginTop: 25 }}>Обновить</Button>
                    </Grid >
                </div> : ""}
        </div>
    );
}

export default Segment;
